<template>
    <div class="hero-container pa-4 pa-sm-11 pa-md-12 rounded-16">


        <div class="hero-image-container">
            <slot name="hero-image"></slot>
        </div>





        <div class="h-100 main-content w-67 w-sm-50 d-flex flex-column justify-center">

            <div class="text-18 text-md-h4 font-weight-bold text-left">
                <slot name="hero-title"></slot>
            </div>



            <div class="text-14 text-md-subtitle-1" style="letter-spacing: 0.6px;">
                <slot name="hero-subtitle"></slot>
            </div>

        </div>


    </div>
</template>



<script>

import { isMobile } from "@/utils/utils.ts";

export default {
    name: 'HeroComponent',
    props: {
        smallWidth: {
            type: Boolean,
            default: true
        },
    },
    setup(props, { emit }) {
        const isMobileDevice = isMobile();
        return {
            isMobileDevice,
        };
    },
}
</script>

<style scoped lang="scss">

.hero-container {
    height: vars.get-map-value(vars.$hero, 'desktop-height');
    overflow: hidden !important;
    box-shadow: vars.get-map-value(vars.$hero, 'box-shadow');
    position: relative;

    @media screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
        height: vars.get-map-value(vars.$hero, 'tab-height');
    }
}

.hero-image-container {
    z-index: 1;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: vars.get-map-value(vars.$hero, 'desktop-height');

    @media screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
        height: vars.get-map-value(vars.$hero, 'tab-height');
    }
}

.main-content {
    position: relative;
    z-index: 2 !important;
}
</style>
